import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles';

const FooterLink = ({ to, children }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Link
      to={to}
      style={{ ...styles.navItem, display: 'inline-block' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      <span
        style={{
          position: 'absolute',
          width: hovered ? '100%' : '0',
          height: '2px',
          bottom: '-4px',
          left: '0',
          backgroundColor: '#1B2B3E',
          transition: 'width 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
        }}
      />
    </Link>
  );
};

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div className="footer-grid" style={styles.footerGrid}>
          <div>
            <img
              src="/logo.png"
              alt="FCR Credit Solutions"
              style={{ height: '36px', display: 'block', marginBottom: '12px' }}
            />
            <div style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6', marginTop: '8px' }}>
              4193 Flat Rock Dr, Bldg 200<br />
              Riverside, CA 92505
            </div>
            <div style={{ fontSize: '14px', color: '#475569', marginTop: '4px' }}>
              888.271.2293
            </div>
            <div style={styles.copyright}>
              &copy; 2026 FCR Credit Solutions. All rights reserved.
            </div>
          </div>
          <div className="footer-links" style={styles.navLinks}>
            <FooterLink to="/privacy">Privacy</FooterLink>
            <FooterLink to="/terms">Terms</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
